const loadingTransitionDurationMs = 200;
const sizes = {
  dialogMaxHeight: 560,
  headerHeight: 60,
  footerMinHeight: 70
};
const overlay = "_275o11hm14c";
const container = "_275cunih39";
const header = "_275hh18p9a";
const heading = "_275h1d6gpv1";
const closeButton = "_275c4rbnze";
const messagesContainer = "_275m1xsvjfr";
const loading = "_275lbpksdz";
const messagesWrapper = "_275m1ok7uw4";

export { closeButton, container, header, heading, loading, loadingTransitionDurationMs, messagesContainer, messagesWrapper, overlay, sizes };
import "./overlay.dialog.style.linaria.module.css";
//# sourceMappingURL=overlay.dialog.style.js.map
